import { httpClient, convResp, customerHttp } from "./_http"


/**
 * @desc 获取历史下单箱数量
 * @param {{portIds: Arrary<string>, startDate: string, endDate: string}} payload 
 */
export const fetchContainerHistory = (payload) => {
  return httpClient.post("/duckBill/listStatisticsContainerNum", payload).then(convResp)
}

/**
 * @desc 统计当前登入的公司做过箱的港口和做箱量，排序为做箱量从大到小
 * @param {{ startDate: string, endDate: string }} payload 
 */
export const fetchContainerPortAndNum = (payload) => {
  return httpClient.post("/duckBill/listStatisticsPortAndContainerNum", payload).then(convResp)
}

export const changeTime = (payload) => {
  return httpClient.post("/duckBill/listStatisticsPortAndContainerNum", payload).then(convResp)
}


/**
 * @desc 通过查询条件统计指定公司月做箱量
 * @param {{portIds: Arrary<string>}} payload 
 */
export const fetchMonthContainerHistory = (payload) => {
  return httpClient
    .post("/duckBill/listStatisticsMonthContainerNum", payload)
    .then(convResp);
}


/**
 * @desc 查询下单前数据
 * @param {{portIds: Arrary<string>}} payload 
 */
export const fetchPlaceOrderData = (payload) => {
  return httpClient
    .post("/duckBill/careDataBeforePlaceOrder", payload)
    .then(convResp)
}

/**
 * @desc 下单前置检查, 查询下单前是否有未确认账单
 */

export const checkBill = () => {
  return httpClient.get("/duckBill/order/checkUnConfirmedCharge")
}

export const uploadDocumentTemplate = (payload) => {
  return httpClient
    .post("/duckBill/uploadDocumentTemplate/createOrder", payload, {headers:{
      'Content-Type': null
    }})
}


export const querySnapshot = (payload) => {
  return customerHttp.post("/search-price/query/snapshot", payload)
}


// WEBPACK FOOTER //
// ./src/api/containerBalance.js